import { get } from 'lodash';
import { RegionType, SocialFollowButtons, } from '@wix/shoutout-email-model-v3';
import { verifyOrFallbackTextColor } from '../../utils/verify-or-fallback';
import * as cssUtils from '../../utils/css-utils';
import getSocialIconUrl from './get-social-icon-url';
import { resolveIconSize, resolveInnerPadding, resolveTitle } from './utils';
const nameToAltTextKey = {
    [SocialFollowButtons.facebook]: 'COMPOSER.FOLLOW.ALT.FACEBOOK',
    [SocialFollowButtons.instagram]: 'COMPOSER.FOLLOW.ALT.INSTAGRAM',
    [SocialFollowButtons.linkedIn]: 'COMPOSER.FOLLOW.ALT.LINKEDIN',
    [SocialFollowButtons.pinterest]: 'COMPOSER.FOLLOW.ALT.PINTEREST',
    [SocialFollowButtons.soundCloud]: 'COMPOSER.FOLLOW.ALT.SOUNDCLOUD',
    [SocialFollowButtons.twitter]: 'COMPOSER.FOLLOW.ALT.TWITTER',
    [SocialFollowButtons.youtube]: 'COMPOSER.FOLLOW.ALT.YOUTUBE',
    [SocialFollowButtons.tiktok]: '',
};
export function getFollowSection({ region, css, }) {
    if (region.type !== RegionType.Follow) {
        throw Error('Follow must be passed');
    }
    const fallbackIconColor = get(css, 'so-global-footer-icon.fill');
    const iconColor = verifyOrFallbackTextColor(get(css, 'so-global-region-follow-icon.fill', fallbackIconColor));
    const socialButtons = {
        size: resolveIconSize(region.data),
        innerPadding: resolveInnerPadding(region.data),
        buttons: region.data.socialButtons
            .filter((item) => item.active)
            .filter(isValidSocialNetwork)
            .map((item) => ({
            name: item.name,
            url: item.url,
            active: item.active,
            iconUrl: getSocialIconUrl(item.name, iconColor),
            alt: nameToAltTextKey[item.name],
        })),
    };
    const rules = [css['so-global-region-follow'], css['so-global-region']];
    const mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true);
    const padding = cssUtils.padding(rules);
    const margin = cssUtils.margin(rules);
    return {
        cssClass: mobileCssClass,
        title: resolveTitle(css, region.data),
        socialButtons,
        outerPadding: margin,
        innerPadding: padding,
    };
}
function isValidSocialNetwork(social) {
    return [
        SocialFollowButtons.facebook,
        SocialFollowButtons.instagram,
        SocialFollowButtons.linkedIn,
        SocialFollowButtons.pinterest,
        SocialFollowButtons.soundCloud,
        SocialFollowButtons.twitter,
        SocialFollowButtons.youtube,
        SocialFollowButtons.tiktok,
    ].includes(social.name);
}
//# sourceMappingURL=get-follow-section.js.map